// Configuration for API settings
export const API_CONFIG = {
  PLACES_AUTOCOMPLETE: "https://places.googleapis.com/v1/places:autocomplete", // Example endpoint
  GEOCODING: "https://maps.googleapis.com/maps/api/geocode/json", // Example endpoint
};

// Default fallback location for map center
export const DEFAULT_CENTER_LOCATION: google.maps.LatLngLiteral = {
  lat: 46.6621, // Chehalis, Washington, USA, close to the Chehalis River and Interstate 5.
  lng: -122.964,
};

// Default fallback zoom level for map
export const DEFAULT_ZOOM_LEVEL: number = 10; // Standard zoom level for city view

// Default fallback center for Places API autocomplete
export const DEFAULT_AUTOCOMPLETE_CENTER_LOCATION: google.maps.LatLngLiteral = {
  lat: 46.6621, // Chehalis, Washington, USA, close to the Chehalis River and Interstate 5.
  lng: -122.964,
};

// Default fallback radius (meters) for Places API autocomplete
export const DEFAULT_AUTOCOMPLETE_RADIUS: number = 50000.0; // 60 km radius
